import { useEffect, useState } from "react";

// Wide-screen breakpoint: width AND a minimum height. Width alone isn't enough -
// a phone rotated to landscape (e.g. 932x430) is wide but too short for the wide
// layout to make sense, so it's excluded via min-height. Unfolded foldables,
// tablets and desktop browsers clear both (e.g. iPad landscape is 1024x768) and
// get the wide layout; normal-width portrait phones stay below the width check.
const QUERY = "(min-width: 768px) and (min-height: 500px)";

export function useWideScreen() {
  const [wide, setWide] = useState(() =>
    typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia(QUERY).matches
      : false
  );
  useEffect(() => {
    if (!window.matchMedia) return;
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setWide(e.matches);
    setWide(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return wide;
}
